import { withPrefix } from 'gatsby-link'
import PropTypes from 'prop-types'
import React from 'react'

import ContactButton from './ContactButton'
import Description from './Description'
import Logo from './Logo'
import Wrapper from './Wrapper'

const Hero = ({ logo, description }) => (
  <Wrapper>
    <Logo src={logo} alt="Pacha Business Services" />
    <Description>{description}</Description>
    <ContactButton />
  </Wrapper>
)

Hero.propTypes = {
  logo: PropTypes.string,
  description: PropTypes.string,
}

export default Hero



// WEBPACK FOOTER //
// ./src/containers/Hero/Hero.js